export const DepositBonusType = {
  LadderDeposit: "Ladder Deposit",
  IsolatedDeposit: "Isolated Deposit",
};
